import styled, { css } from "styled-components";
import ArrowLeftIcon from "../components/icon/arrowLeftIcon";
import ArrowRightIcon from "../components/icon/arrowRightIcon";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import CloseIcon from "../components/icon/closeIcon";
import { Image } from "../components/common/image";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getContractImageList } from "../repositories/AppRepository";
import CustomButton from "../components/common/customButton";

const Wrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100vw;
  height: 100vh;
  background-color: white;
`;

const TopArea = styled.div`
  margin-top: 2vw;
  width: 80vw;
  height: 6vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LeftArea = styled.div`
  width: 35%;
  height: 100%;
  display: flex;
  align-items: center;
`;

const TextBox = styled.div`
  width: 20vw;
  height: 5vw;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.4vw;
  font-size: 1.8vw;
  background-color: #f0f0f0ab;
`;

const MidArea = styled.div`
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
const RightArea = styled.div`
  width: 35%;
  height: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
`;

const CloseBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  &&:hover {
    cursor: pointer;
  }
`;

const ContractWrapper = styled.div`
  margin-top: 1vh;
  width: 80vw;
  height: 113vw;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.8vw;
  border: 0.16vw solid gray;
`;

const ContractArea = styled.div`
  width: 98%;
  height: 98%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PrevBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 5vw;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#e7e7e7")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;

const NumBox = styled.div`
  width: 13vw;
  height: 5vw;
  background-color: #e7e7e7;
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.4vw;
  font-weight: 600;
`;

const NextBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 5vw;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#e7e7e7")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;

const DownloadButton = styled.div`
  width: 160px;
  height: 5vw;
`;

const BottomArea = styled.div`
  margin-top: 1vw;
  width: 80vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
`;

const ThumbnailBox = styled.div<{ $index: number; $currentPage: number }>`
  width: 7vw;
  outline: 0.1vw solid gray;
  margin-right: 1vw;
  margin-bottom: 1.2vw;
  border-radius: 0.1vw;
  ${(props) =>
    props.$index === props.$currentPage - 1 &&
    css`
      outline: 0.3vw solid #ff7f3b;
    `}
  &:hover {
    cursor: pointer;
  }
`;

export default function ContractViewer(props: any) {
  const reNum = useParams().id;

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [prevBoxActive, setPrevBoxActive] = useState<boolean>(false);
  const [nextBoxActive, setNextBoxActive] = useState<boolean>(true);
  const [maxIndex, setMaxIndex] = useState<number>(2);
  const [contractImageList, setContractImageList] = useState([]);

  const openContractImage = (path: string) => {
    window.open(`https://homenmove.net/${path}`);
  };

  const clickPrevPage = (e: any) => {
    if (currentPage <= 1) {
      return;
    } else {
      setCurrentPage(currentPage - 1);
    }
  };

  const clickNextPage = (e: any) => {
    if (currentPage >= maxIndex) {
      return;
    }
    setCurrentPage(currentPage + 1);
  };

  const onclickThumbnail = (index: number) => {
    setCurrentPage(index + 1);
  };

  const downloadImages = async () => {
    // 계약 이미지 리스트가 충분한지 확인
    if (contractImageList.length < 2) {
      alert("다운로드할 이미지가 부족합니다.");
      return;
    }

    const zip = new JSZip();
    const urls = contractImageList
      .slice(0, 2)
      .map((item: any) => `https://homenmove.net/${item.path}`);

    // 이미지 다운로드 및 ZIP에 추가
    const promises = urls.map(async (url, index) => {
      const response = await fetch(url); // 이미지 다운로드
      const blob = await response.blob(); // Blob 객체로 변환
      zip.file(`image_${index + 1}.jpg`, blob); // ZIP에 이미지 추가
    });

    await Promise.all(promises); // 모든 이미지 다운로드 완료 기다리기

    // ZIP 파일 생성 및 다운로드
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "contract_images.zip"); // 생성된 ZIP 파일 다운로드
    });
  };

  useEffect(() => {
    if (reNum) {
      const fetchImage = async () => {
        const result = await getContractImageList(reNum);
        setContractImageList(result.slice(0, 2));
      };
      fetchImage();
    }
  }, []);

  useEffect(() => {
    if (currentPage <= 1) {
      setPrevBoxActive(false);
      setNextBoxActive(true);
    } else {
      setPrevBoxActive(true);
      if (currentPage >= maxIndex) {
        setNextBoxActive(false);
      } else {
        setNextBoxActive(true);
      }
    }
  }, [currentPage]);

  return (
    <>
      <Wrapper>
        <TopArea>
          <LeftArea></LeftArea>
          <MidArea>
            <PrevBox $isActivate={prevBoxActive}>
              <ArrowLeftIcon
                onClick={(e: any) => clickPrevPage(e)}
                width={"4.2vw"}
                height={"4.2vw"}
                fill={"white"}
              />
            </PrevBox>
            <NumBox>
              {currentPage} / {maxIndex}
            </NumBox>
            <NextBox $isActivate={nextBoxActive}>
              <ArrowRightIcon
                onClick={(e: any) => clickNextPage(e)}
                width={"4.2vw"}
                height={"4.2vw"}
                fill={"white"}
              />
            </NextBox>
          </MidArea>
          <RightArea>
            <DownloadButton>
              <CustomButton
                onClick={downloadImages}
                text="다운로드"
                width="100%"
                height="100%"
              ></CustomButton>
            </DownloadButton>
          </RightArea>
        </TopArea>
        <ContractWrapper>
          <ContractArea>
            {contractImageList.map((item: any, index: number) => {
              if (index + 1 === currentPage) {
                return (
                  <>
                    <Image
                      onClick={(e: any) => openContractImage(item.path)}
                      src={`https://homenmove.net/${item.path}`}
                      width={"100%"}
                      height={"100%"}
                      key={index}
                    ></Image>
                  </>
                );
              }
            })}
          </ContractArea>
        </ContractWrapper>
        <BottomArea>
          {contractImageList.map((item: any, index: number) => {
            return (
              <ThumbnailBox
                key={index}
                $index={index}
                $currentPage={currentPage}
                onClick={(e: any) => onclickThumbnail(index)}
              >
                <Image
                  src={`https://homenmove.net/${item.path}`}
                  width={"100%"}
                  height={"100%"}
                ></Image>
              </ThumbnailBox>
            );
          })}
        </BottomArea>
      </Wrapper>
    </>
  );
}
